export default __webpack_public_path__ + "static/media/gift.2a079d50.jpeg";